import type { ContentBlock } from '../chat-content';
import { ActionListBlockRenderer } from './action-list-block';
import { AvatarListBlockRenderer } from './avatar-list-block';
import { CardBlockRenderer } from './card-block';
import { CardListBlockRenderer } from './card-list-block';
import { ChartBlockRenderer } from './chart-block';
import { CodeBlockRenderer } from './code-block';
import { MediaBlockRenderer } from './media-block';
import { StatBlockRenderer } from './stat-block';
import { TableBlockRenderer } from './table-block';
import { TextBlockRenderer } from './text-block';
import { ToolCallBlockRenderer } from './tool-call-block';

export function MessageBlockRenderer({ block }: { block: ContentBlock }) {
  switch (block.type) {
    case 'text':
      return <TextBlockRenderer block={block} />;
    case 'code':
      return <CodeBlockRenderer block={block} />;
    case 'table':
      return <TableBlockRenderer block={block} />;
    case 'chart':
      return <ChartBlockRenderer block={block} />;
    case 'media':
      return <MediaBlockRenderer block={block} />;
    case 'tool_call':
      return <ToolCallBlockRenderer block={block} />;
    case 'card':
      return <CardBlockRenderer block={block} />;
    case 'card_list':
      return <CardListBlockRenderer block={block} />;
    case 'stat':
      return <StatBlockRenderer block={block} />;
    case 'action_list':
      return <ActionListBlockRenderer block={block} />;
    case 'avatar_list':
      return <AvatarListBlockRenderer block={block} />;
    default:
      return null;
  }
}
